import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";

const { post, get, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "alternate-ID";

export type generateAlternateIDPayloadTypes = {
	group_number: number;
	first_name: string;
	last_name: string;
	date_of_birth: string;
};

export const getAlternateID = async (_payload: generateAlternateIDPayloadTypes) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/generate-alternate-id-member`;
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response?.data?.result) {
			return {
				...response.data.result,
				message: response.data.message
			};
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};
